<script>

    import Moment from 'moment'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import DateRangeNav from '../$components/date.range.nav.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import ModalContainer from '../$components/modal.container.svelte'

    import TrackingsComponent from './component.trackings.svelte'
    import TrackingsDownloadComponent from './component.download.svelte'

    let dateStart = Moment().startOf('month').startOf('day').toDate()
    let dateEnd = Moment().endOf('month').endOf('day').toDate()

</script>

<style>
    .trackings-toolbar {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 0.75rem;
        margin-bottom: 1.25rem;
    }
</style>

<View>
    <PageHeader title="Trackings" subtitle="Escaneos de drivers en envíos TIL" />

    <div class="trackings-toolbar">
        <ButtonModal modalId="tilTrackings_download_modal" icon="download" text="Descargar reporte" />
        <DateRangeNav bind:dateStart bind:dateEnd />
    </div>

    <TrackingsComponent {dateStart} {dateEnd} />
</View>

<ModalContainer id="tilTrackings_download_modal" title="Descargar reporte de trackings">
    <TrackingsDownloadComponent {dateStart} {dateEnd} />
</ModalContainer>
